var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "base-card",
        [
          _c("v-card-title", [
            _vm._v(" Generador de informe de cantidad de transacciones "),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _vm._v(
                          " El informe solo podrá generarse dentro de un rango de 90 días. "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              ref: "dialog",
                              attrs: { persistent: "", width: "300px" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "Rango de fechas",
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                                required: "",
                                                "error-messages":
                                                  _vm.dateRangeErrorMessage,
                                                rules: _vm.ruleTimestap,
                                              },
                                              model: {
                                                value:
                                                  _vm.processedDocsData
                                                    .dateRange,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.processedDocsData,
                                                    "dateRange",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "processedDocsData.dateRange",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.modal,
                                callback: function ($$v) {
                                  _vm.modal = $$v
                                },
                                expression: "modal",
                              },
                            },
                            [
                              _c(
                                "v-date-picker",
                                {
                                  attrs: {
                                    range: "",
                                    min: _vm.minDate,
                                    max: _vm.maxDate,
                                    "disabled-dates": _vm.disabledDates,
                                  },
                                  on: { input: _vm.onDateRangeInput },
                                  model: {
                                    value: _vm.processedDocsData.dateRange,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.processedDocsData,
                                        "dateRange",
                                        $$v
                                      )
                                    },
                                    expression: "processedDocsData.dateRange",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "end" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mr-2",
                                          staticStyle: {
                                            "background-color": "gray",
                                            color: "white !important",
                                          },
                                          attrs: { text: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.modal = false
                                            },
                                          },
                                        },
                                        [_vm._v(" Cancel ")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            "background-color":
                                              "rgb(204 33 40)",
                                            color: "white !important",
                                          },
                                          attrs: { text: "" },
                                          on: { click: _vm.onAccept },
                                        },
                                        [_vm._v(" OK ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-text-field", {
                            ref: "Nit",
                            attrs: {
                              label: "Correo",
                              counter: "",
                              maxlength: "80",
                              "prepend-inner-icon": "mdi-email",
                              required: "",
                              rules: _vm.ruleEmail,
                            },
                            model: {
                              value: _vm.processedDocsData.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.processedDocsData, "email", $$v)
                              },
                              expression: "processedDocsData.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12", sm: "1" } }),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              staticStyle: {
                                "background-color": "rgb(204 33 40)",
                                color: "white !important",
                              },
                              attrs: {
                                loading: _vm.isLoading,
                                disabled: _vm.isLoading,
                              },
                              on: { click: _vm.submitForm },
                            },
                            [_vm._v(" Generar ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              attrs: { color: "gray", disabled: _vm.isLoading },
                              on: { click: _vm.clearForm },
                            },
                            [_vm._v(" Limpiar ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _vm.showAlert
                            ? _c(
                                "v-alert",
                                { attrs: { type: _vm.alertType, text: "" } },
                                [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }